import { BooksyInstructions } from './BooksyInstructions';
import { GenericInstructions } from './GenericInstructions';
import { PlatformNotSelectedInstructions } from './PlatformNotSelectedInstructions';
import { TheCutInstructions } from './TheCutInstructions';
import { SquareInstructions } from './SquareInstructions';
var instructionsByPlatform = {
    empty: PlatformNotSelectedInstructions,
    generic: GenericInstructions,
    booksy: BooksyInstructions,
    thecut: TheCutInstructions,
    square_aka_block: SquareInstructions,
};
export var getInstructionsComponentByPlatform = function (platform) {
    return instructionsByPlatform[platform] || (platform ? instructionsByPlatform.generic : instructionsByPlatform.empty);
};
